import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {
    CButton,
    CCard,
    CCardBody,
    CCardGroup,
    CCol,
    CContainer,
    CForm,
    CInputGroup,
    CInputGroupPrepend,
    CInputGroupText,
    CRow
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {Formik} from "formik";
import {Input} from "../../../components/form";
import AuthService from "../../../services/auth";

const Login = () => {
    const [initialValues] = useState({email: '', password: ''});
    const history = useHistory()
    const user = useSelector(state => state.user)

    useEffect(() => {
        document.title = "Авторизация"
    }, [])

    useEffect(() => {
        if (user && user.accessToken) {
            history.push("/");
        }
    }, [history, user])

    const onSubmit = (values, {setSubmitting, setErrors}) => {
        AuthService.login(values).catch((error) => {
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data);
            } else {
                toast.error("Что-то пошло не так :(");
            }
        }).finally(() => {
            setSubmitting(false)
        });
    }

    return (
        <div className="c-app c-default-layout flex-row align-items-center">
            <CContainer>
                <CRow className="justify-content-center">
                    <CCol md="4">
                        <CCardGroup>
                            <CCard className="p-4">
                                <CCardBody>
                                    <Formik
                                        initialValues={initialValues}
                                        onSubmit={onSubmit}
                                    >
                                        {({
                                              isSubmitting,
                                              handleSubmit,
                                          }) => (
                                            <CForm>
                                                <h1 className="mb-4">Авторизация</h1>
                                                {/*<p className="text-muted">Sign In to your account</p>*/}
                                                <CInputGroup className="mb-3">
                                                    <CInputGroupPrepend>
                                                        <CInputGroupText>
                                                            <CIcon name="cil-user"/>
                                                        </CInputGroupText>
                                                    </CInputGroupPrepend>
                                                    <Input
                                                        name="email"
                                                        placeholder="Email"
                                                    />
                                                </CInputGroup>
                                                <CInputGroup className="mb-4">
                                                    <CInputGroupPrepend>
                                                        <CInputGroupText>
                                                            <CIcon name="cil-lock-locked"/>
                                                        </CInputGroupText>
                                                    </CInputGroupPrepend>
                                                    <Input
                                                        name="password"
                                                        placeholder="Пароль"
                                                        type="password"
                                                        autoComplete="current-password"
                                                    />
                                                </CInputGroup>
                                                <CRow>
                                                    <CCol xs="6">
                                                        <CButton color="primary" disabled={isSubmitting} onClick={handleSubmit}
                                                                 className="px-4">Войти</CButton>
                                                    </CCol>
                                                    {/*<CCol xs="6" className="text-right">
                        <CButton color="link" className="px-0">Forgot password?</CButton>
                      </CCol>*/}
                                                </CRow>
                                            </CForm>
                                        )}
                                    </Formik>
                                </CCardBody>
                            </CCard>
                            {/*<CCard className="text-white bg-primary py-5 d-md-down-none" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua.</p>
                    <Link to="/register">
                      <CButton color="primary" className="mt-3" active tabIndex={-1}>Register Now!</CButton>
                    </Link>
                  </div>
                </CCardBody>
              </CCard>*/}
                        </CCardGroup>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    )
}

export default Login
